angular.module('salesPath2')
  .controller('applicationDisabledModalCtrl', ['$scope', '$sce', '$filter', 'RESOURCES',
    function($scope, $sce, $filter, RESOURCES) {
      var content = $filter('translate')('sp2.modal.packageClosedInfoMsg');
      $scope.message = $sce.trustAsHtml(content.replace(/(?:\r\n|\r|\n)/g, '<br />').replace('{APP}', RESOURCES.APP_FULLNAME));

      /**
      * init
      */
      $scope.init = function() {
        
      };

      $scope.init();

    }
  ]);
